import React from "react";
import BaseList from "../BaseList";
import { momentTimeWithShortName } from "../../helpers/date_functions";
import _ from "lodash";
import I18n from "../../common/I18n";
import { Tag } from "antd";
import { ChevronDownIcon } from "../../common/CustomIcon";

class NotificationList extends BaseList {
  constructor(props) {
    super(props);
    this.columns = [];
    this.expandIcon = (props) => {
      const { expanded, onExpand, record } = props;
      return (
        <span
          onClick={(e) => onExpand(record, e)}
          style={{ cursor: "pointer" }}
        >
          {expanded ? (
            <ChevronDownIcon
              color="#313D6B"
              style={{ transform: "rotate(180deg)" }}
            />
          ) : (
            <ChevronDownIcon color="#313D6B" />
          )}
        </span>
      );
    }
    this.setColumns(props);
  }
    setColumns = (props) => {
    const { isMilitaryTime } = props;
    const displayFormat = isMilitaryTime ? 'MMM D, YYYY HH:mm' : 'MMM D, YYYY hh:mm A';
    this.columns = [
      {
        // title: I18n.t("general.table_s_no"),
        title: "#",
        key: "index",
        render: (text, record, index) => index + 1,
        width: 40,
      },
      {
        // title: I18n.t("notifications.logs.mobile"),
        title: "To",
        key: "notification_sent_to",
        dataIndex: "send_to",
        width: 170,
      },
      {
        title: "Sent By",
        key: "notification_sent_by",
        dataIndex: "send_by",
        render: (text, record, index) => (
          <div className="textCaptilize">{record.sent_by}</div>
        ),
        width: 90,
      },
      {
        // title: I18n.t("notifications.logs.notify_type"),
        title: "Type",
        key: "notification_type",
        dataIndex: "notification_type",
        render: (text, record, index) => (
          <div className="textUpperCase">{text}</div>
        ),
        width: 70,
      },
      {
        title: I18n.t("notifications.logs.sent_to"),
        key: "notification_for",
        dataIndex: "notification_for",
        width: 100,
      },
      {
        title: I18n.t("notifications.logs.event"),
        key: "notification_event",
        dataIndex: "notification_event",
        render: (text, record, index) => (
          <div className="textCaptilize">{text}</div>
        ),
        width: 100,
      },
      {
        title: I18n.t("general.status"),
        key: "notification_delivery_status",
        dataIndex: "notification_delivery_status",
        render: (status) => (
          <Tag
            style={{
              borderRadius: "24px",
              color: status === "FAILED" ? "#D23B71" : "#576EC1",
              backgroundColor: status === "FAILED" ? "#FBD9E5" : "#E2E6F5",
            }}
          >
            {status}
          </Tag>
        ),
        width: 90,
      },
      {
        title: I18n.t("notifications.logs.sent_on"),
        key: "created_at",
        dataIndex: "created_at",
        width: 175,
        render: (data) =>
          data ? (
            <div>
              {momentTimeWithShortName(
                displayFormat,
                data,
                this.props.timeZone,
                this.props.timeZoneName
              )}
            </div>
          ) : (
            "NA"
          ),
      },
    ];
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps, this.props)) {
      this.columns = [];
      this.setColumns(this.props);
    }
  }
}
export default NotificationList;
